import { Controller } from "@hotwired/stimulus"

// Caps a nested-form list on the client: disables the "add" button (and shows a hint) once the number
// of active rows reaches `max`. Rows removed via nested-form are hidden + flagged `_destroy`, so they're
// excluded from the count. Recounts on any add/remove via a MutationObserver.
export default class extends Controller {
  static targets = ["add", "hint"]
  static values = { max: Number }

  connect() {
    this.observer = new MutationObserver(() => this.refresh())
    // Rows are added/removed by nested-form (childList) or hidden via inline style on remove — watch
    // only those. Not "class", so answer-badge's live badge restyling doesn't trigger recounts.
    this.observer.observe(this.element, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style"],
    })
    this.refresh()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  activeCount() {
    return Array.from(this.element.querySelectorAll(".nested-form-wrapper")).filter(row => {
      if (row.classList.contains("hidden") || row.style.display === "none") return false
      const destroy = row.querySelector("input[name*='_destroy']")
      return !(destroy && destroy.value === "1")
    }).length
  }

  refresh() {
    const atMax = this.activeCount() >= this.maxValue

    if (this.hasAddTarget) {
      this.addTarget.disabled = atMax
      this.addTarget.classList.toggle("opacity-50", atMax)
      this.addTarget.classList.toggle("pointer-events-none", atMax)
    }
    if (this.hasHintTarget) {
      this.hintTarget.classList.toggle("hidden", !atMax)
    }
  }
}
